import QRCode from 'qrcode.react';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 306px;
  height: fit-content;
  padding: ${p => p.theme.app.padding.vertical};
`;

export const Hr = styled.hr<{ type: string }>`
  border-top: 1px ${p => p.type} black;
  width: 100%;
  margin: 4px 0px;
`;

export const RowInfo = styled.div<{
  width?: number;
  left?: number;
  right?: number;
  justify?: string;
}>`
  display: flex;
  position: relative;
  justify-content: ${p => (p.justify ? p.justify : 'flex-start')};
  width: ${props => (props.width ? `${props.width}px` : '100%')};
  .info {
    position: absolute;
    ${p => p.left && `left: ${p.left || 200}px;`}
    ${p => p.right && `right: ${p.right || 200}px;`}
  }
  height: fit-content;
`;

export const RowTableInfo = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: fit-content;
`;

export const CQRCode = styled(QRCode)`
  width: 100px !important;
  height: 100px !important;
`;
